import { IAttendance } from "./IGameAttendances";

export interface IGameAttendancesVotes extends IAttendancesVotes {
  GameAttendances: IAttendance | null;
}

export interface IAttendancesVotes {
  created_at: string;
  game_attendance_id: number;
  id: number;
  player_id: number;
  type: string;
}

export enum VoteType {
  // Existing (TRAINING/COMPETITIVE)
  CREATIVITY = "creativity",
  DEFENSE = "defense",
  EFFORT = "effort",
  
  // New (ORGANIZATION_MATCH)
  OPPONENT_OVERALL = "OPPONENT_OVERALL",
  TEAMMATE_EFFORT = "TEAMMATE_EFFORT",
  TEAMMATE_DEFENSE = "TEAMMATE_DEFENSE",
  TEAMMATE_CREATIVITY = "TEAMMATE_CREATIVITY",
}
